module.exports = __webpack_public_path__ + "img/shopping-mall.500915a4.png";